<template>
  <div class="topImg" :style="{backgroundImage: 'url(' + url + ')'}"></div>
</template>
<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="less" scoped>
.topImg {
  width: 100%;
  height: 7rem;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-top-right-radius: 4rem;
  border-bottom-left-radius: 4rem;
}
</style>
